var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2561_13980",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2561_13980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM10 16.75H12.9423C13.4474 16.75 13.875 16.575 14.225 16.225C14.575 15.875 14.75 15.4474 14.75 14.9423V13.0577C14.75 12.5526 14.575 12.125 14.225 11.775C13.875 11.425 13.4474 11.25 12.9423 11.25H10.75V8.75H14C14.2125 8.75 14.3906 8.67808 14.5343 8.53425C14.6781 8.39042 14.75 8.21225 14.75 7.99975C14.75 7.78708 14.6781 7.609 14.5343 7.4655C14.3906 7.32183 14.2125 7.25 14 7.25H10.1537C9.89775 7.25 9.68308 7.33625 9.50975 7.50875C9.33658 7.68108 9.25 7.89767 9.25 8.1585V11.8415C9.25 12.1023 9.33658 12.3189 9.50975 12.4913C9.68308 12.6637 9.89775 12.75 10.1537 12.75H12.9423C13.0321 12.75 13.1058 12.7788 13.1635 12.8365C13.2212 12.8942 13.25 12.9679 13.25 13.0577V14.9423C13.25 15.0321 13.2212 15.1058 13.1635 15.1635C13.1058 15.2212 13.0321 15.25 12.9423 15.25H10C9.7875 15.25 9.60942 15.3219 9.46575 15.4658C9.32192 15.6096 9.25 15.7878 9.25 16.0003C9.25 16.2129 9.32192 16.391 9.46575 16.5345C9.60942 16.6782 9.7875 16.75 10 16.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber5);
export default __webpack_public_path__ + "static/media/Number-5.f829aa0cc139ba960f8f968110e0063a.svg";
export { ForwardRef as ReactComponent };